import { getLogoutUri } from "../auth/authConfig";
import { getMsalInstance } from "../auth/msalClient";

export default class AuthenticationFailureHandler {
  /**
   * Handles authentication failure (e.g. 401). Clears session, then reloads
   * so MSAL can re-acquire tokens or redirect to Entra login.
   */
  static execute = () => {
    sessionStorage.clear();
    globalThis.location.reload();
  };

  /**
   * Logs out the user by clearing the session and redirecting to Entra logout.
   */
  static logout = async () => {
    sessionStorage.clear();
    const msalInstance = getMsalInstance();

    if (msalInstance) {
      try {
        const activeAccount =
          msalInstance.getActiveAccount() || msalInstance.getAllAccounts()[0];

        await msalInstance.logoutRedirect({
          account: activeAccount || undefined,
          postLogoutRedirectUri: globalThis.location.origin,
        });

        return;
      } catch (error) {
        console.warn(
          "MSAL logoutRedirect failed, falling back to logout URI",
          error
        );
      }
    }

    const logoutUri = getLogoutUri();

    globalThis.location.href = logoutUri?.startsWith("https://")
      ? logoutUri
      : globalThis.location.origin;
  };
}
